import { useForm } from 'react-hook-form';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { useTextOnlyKeyDown } from 'hooks/util/useTextOnlyKeyDown';
import {
  KioskButtonRowGroup,
  KioskEntryButton,
  KioskEntryInput,
  KioskEntryMessageBoxStyled,
  KioskRowGroup,
} from 'containers/public/kiosk/Kiosk.styled';
import { KioskLayout } from 'containers/public/kiosk/KioskLayout';
import { KioskTextInputHintWrap } from './KioskInputHynt';

export const KioskEntrySurnameInitial = ({
  onSurnameInitialSubmitted,
  onBackClicked,
  onUserActivity,
}: {
  onSurnameInitialSubmitted: (surnameInitial: string) => void;
  onBackClicked: () => void;
  onUserActivity: () => void;
}) => {
  const { t } = useCommonTranslation();
  const textOnlyKeyDownHandler = useTextOnlyKeyDown();
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm<{
    surnameInitial: string;
  }>({ defaultValues: { surnameInitial: '' }, mode: 'onChange' });

  const onSubmit = handleSubmit((values) => {
    onSurnameInitialSubmitted(values.surnameInitial.toLocaleUpperCase());
    onUserActivity();
  });

  return (
    <KioskLayout>
      <KioskEntryMessageBoxStyled>
        <KioskTextInputHintWrap
          inputHint={t('kiosk-checkin-surname-initial-hint')}
        >
          <form onSubmit={onSubmit}>
            <KioskRowGroup>
              <KioskEntryInput
                style={{ flex: 1 / 3, textTransform: 'uppercase' }}
                type="text"
                maxLength={1}
                autoFocus
                onKeyDown={(e) => {
                  textOnlyKeyDownHandler(e);
                  onUserActivity();
                }}
                {...register('surnameInitial', { required: true })}
              />
            </KioskRowGroup>
          </form>
        </KioskTextInputHintWrap>

        <KioskButtonRowGroup>
          <KioskEntryButton
            type="button"
            variant="secondary"
            onClick={onBackClicked}
          >
            {t('kiosk-checkin-back-to-birthdate')}
          </KioskEntryButton>
          <KioskEntryButton
            type="submit"
            variant="primary"
            onClick={onSubmit}
            disabled={!isValid}
          >
            {t('next')}
          </KioskEntryButton>
        </KioskButtonRowGroup>
      </KioskEntryMessageBoxStyled>
    </KioskLayout>
  );
};
